export default __webpack_public_path__ + "media/images/archetypes/pollster-77391d1ceb3353fb222e5a55f4959f2c.png";